export default __webpack_public_path__ + "static/pitch-sans-web-medium-italic-77cfdb082f18aa10ad93d1d14b51198c.woff2";